const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "guest",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 37,
    r: 32,
    style: {
      fill: "none",
      stroke: "#a4a4a4",
      strokeMiterlimit: 10,
      strokeWidth: "1.75px"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.21,62.32c4.21-2.84,7.36-5.16,11.38-6.52.87-.5,1.41-1.43,1.41-2.43v-4.55c0-.54-.11-1.08-.32-1.58-1.08-1.56-1.85-3.47-2.4-5.6-.18-.43-.44-.82-.75-1.16l-.95-1.02c-.58-.63-.91-1.45-.91-2.3v-4.34c0-.52.25-1.02.67-1.33h0c.42-.31.67-.81.67-1.33v-5.83c0-3.59,2.28-6.81,5.7-7.91,1.72-.55,3.94-.92,6.8-.92",
    style: {
      fill: "none",
      stroke: "#a4a4a4",
      strokeMiterlimit: 10,
      strokeWidth: "1.7px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5,62.32c-4.2-2.58-7.37-4.96-11.38-6.52-.87-.5-1.41-1.43-1.41-2.43v-4.55c0-.54.11-1.08.32-1.58,1.16-1.65,2-3.49,2.4-5.6.18-.43.44-.82.75-1.16l.95-1.02c.58-.63.91-1.45.91-2.3v-4.34c0-.52-.25-1.02-.67-1.33h0c-.42-.31-.67-.81-.67-1.33v-5.83c0-3.59-2.28-6.81-5.7-7.91-1.72-.55-3.94-.92-6.8-.92",
    style: {
      fill: "none",
      stroke: "#a4a4a4",
      strokeMiterlimit: 10,
      strokeWidth: "1.7px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuest);
export default __webpack_public_path__ + "static/media/guest.0405d60cedae73c5fef0064bcfff97b4.svg";
export { ForwardRef as ReactComponent };